import { interval, Subject, take, takeUntil } from 'rxjs';

export interface NativeSafeAreas {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export class NativeSafeAreaService {
  private win: Window | null = typeof window !== 'undefined' ? window : null;

  private _safeAreas$: Subject<NativeSafeAreas> = new Subject();
  safeAreas$ = this._safeAreas$.asObservable();

  constructor() {
    interval(1000)
      // The setSafeArea function from index.html is only triggered by new app versions.
      // In order to remain downward compatible, we check the first 5 seconds
      // whether the SafeArea has been passed.
      // If the 5 seconds are up or we receive data, we abort and pass on the data.
      .pipe(take(5), takeUntil(this.safeAreas$))
      .subscribe(() => {
        // eslint-disable-next-line
        if ((this.win as any).appInterface === undefined) {
          return;
        }

        // eslint-disable-next-line
        const safeAreas = (this.win as any).appInterface
          .safeArea as NativeSafeAreas;
        if (safeAreas !== undefined) {
          const isSave = this.checkType(JSON.stringify(safeAreas));
          if (isSave === true) {
            this._safeAreas$?.next(safeAreas);
          }
        }
      });
  }

  private checkType(safeAreas: string): boolean {
    const regex = new RegExp('{("[a-z]{3,6}":[0-9]*.?){4}}', 'gm');
    if (safeAreas.match(regex) === null) {
      console.error('Native safe area is not in the correct format');
      return false;
    }
    return true;
  }
}
